module.exports = __webpack_public_path__ + "static/media/couch.8f741b72.svg";